import router from "@/router";

export async function authenticate(username, password) {
  const options = {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: new URLSearchParams({
      client_id: process.env.VUE_APP_CSA_SSO_CLIENT_ID,
      client_secret: process.env.VUE_APP_CSA_SSO_CLIENT_SECRET,
      region: process.env.VUE_APP_CSA_SSO_REGION,
      grant_type: process.env.VUE_APP_CSA_SSO_GRANT_TYPE,
      username: username,
      password: password,
      scope: process.env.VUE_APP_CSA_SSO_SCOPE,
    }),
  };

  try {
    const response = await fetch(
      process.env.VUE_APP_CSA_SSO_URL + "/connect/token",
      options
    );
    return response.json();
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
}

export async function autoSignIn(intendedDestinationParam) {
  const intendedDestination =
    intendedDestinationParam ||
    (router.currentRoute && router.currentRoute.fullPath) ||
    "/";

  if (!process.env.VUE_APP_CSA_USERNAME || !process.env.VUE_APP_CSA_PASSWORD) {
    router.replace({
      name: "login",
      query: { redirect: intendedDestination },
    });
    return false;
  }

  const response = await authenticate(
    process.env.VUE_APP_CSA_USERNAME,
    process.env.VUE_APP_CSA_PASSWORD
  );

  if (response && response.access_token) {
    localStorage.setItem("accessToken", response.access_token);
    if (intendedDestination === "/login" || intendedDestination === "/") {
      router.replace({ name: "home" });
    } else {
      router.replace(intendedDestination);
    }
    return true;
  }

  router.replace({
    name: "login",
    query: { redirect: intendedDestination },
  });
  return false;
}
